import styled, { css } from "styled-components";
import SelectAutoWidth from "../../components/SelectAutoWidth";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const Flex = styled.div`
  display: flex;
  align-items: ${({ items }) => items ?? "flex-start"};
  justify-content: ${({ justify }) => justify ?? "flex-start"};
  flex-direction: ${({ direction }) => direction ?? "row"};
  flex-wrap: ${({ wrap }) => wrap ?? "nowrap"};
  gap: ${({ gap }) => gap ?? "0px"};

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};

  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `};

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `};

  ${({ flex }) =>
    flex &&
    css`
      flex: 1;
    `};

  ${({ full }) =>
    full &&
    css`
      width: 100%;
    `};

  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `};
`;

export const Text = styled.p`
  font-family: "Open Sans";
  letter-spacing: 0%;
  margin-bottom: 0;

  ${({ type }) => {
    switch (type) {
      default:
        return css`
          font-weight: 700;
          font-size: 24px;
          line-height: 100%;
          color: #3a3a3c;
        `;

      case "subtitle":
        return css`
          font-weight: 600;
          font-size: 19.12px;
          line-height: 23.36px;
          color: #002244;
        `;

      case "aside-title":
        return css`
          font-weight: 600;
          font-size: 18px;
          line-height: 23.36px;
          color: #002244;
        `;
      case "aside-text":
        return css`
          font-family: "Inter";
          font-weight: 400;
          font-size: 14px;
          line-height: 100%;
          color: #002244;
          -webkit-line-clamp: 1;
        `;

      case "card-title":
        return css`
          font-family: "Nunito";
          font-weight: 400;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #030229;
        `;

      case "card-text":
        return css`
          font-family: "Nunito";
          font-weight: 800;
          font-size: 26px;
          line-height: 135%;
          color: #030229;
          opacity: 0.7;
        `;
    }
  }};

  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `};
`;

export const Card = styled.div`
  border: 1px solid #ebebf0;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  transition: all 300ms ease-in-out;

  ${({ flex }) =>
    flex &&
    css`
      flex: 1;
    `};

  ${({ noData }) =>
    noData &&
    css`
      opacity: 0;
    `};
`;

export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ background }) =>
    background &&
    css`
      background-color: ${background};
    `};
`;

export const Select = styled(SelectAutoWidth)`
  .ant-select-selection-search {
    padding-right: 18px;
    left: 6px !important;
  }

  .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-open .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }

  .ant-select-selector {
    border: none !important;
    padding-right: 20px !important;
    padding-left: 6px !important;
  }
`;

export const SelectContainer = styled.div`
  border: 1px solid #ebebf0;
  border-radius: 10px;
  padding: 0px 10px;
  height: 40px;
  display: flex;
  align-items: center;
  width: fit-content;
  & .ant-select-selector {
    border: none !important;
    padding-right: 20px !important;
    padding-left: 4px !important;
  }

  & .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-open .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }

  & > span {
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 19.07px !important;
    color: #727272 !important;
  }

  ${({ fit }) =>
    fit &&
    css`
      .ant-select-selection-item {
        width: fit-content !important;
      }
    `}
`;

export const Number = styled.div`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter";
  font-size: 14px;
  color: #000000;
  background: #f1f5f9;
  border-radius: 100%;
`;
